import { EnvDef } from '@atomica.co/utils';

export default EnvDef.STAGING;
